// Taşeron portalı — araç kaydı önbellek geçersiz kılma (§23.2). Belge yükleme/silme ve araç
// yazımları hem kayıt listesini hem her izin detayını (aracı gömer) etkiler.

import type { QueryClient } from '@tanstack/react-query';
import { supplierContractorKeys } from './supplierContractorKeys';
import { supplierPermitKeys } from './supplierPermitKeys';

/** companyId anahtarlarda → firma değişiminde önceki firmanın satırı servis edilmez. */
export function invalidateVehicleCaches(queryClient: QueryClient, companyId: number | null) {
  queryClient.invalidateQueries({ queryKey: supplierContractorKeys.vehicles(companyId) });
  queryClient.invalidateQueries({ queryKey: supplierPermitKeys.all() }); // her izin detayı aracı gömer
}
